import React from 'react'
import Header from './Header';
import AnunciosHome from './AnunciosHome';
import ImagenesHome from './ImagenesHome';
import SeccionPresupuestoHome from './VotacionHomeNuevo';




const Home = () => {
  return (
    <>
    <Header />
    <SeccionPresupuestoHome />
    <AnunciosHome /> 
   

  </>   
  )
}

export default Home